// extracted by mini-css-extract-plugin
export default {"mainContentWrapper":"_MainContent_mainContentWrapper__0SQwW","mainContentImg":"_MainContent_mainContentImg__-TWr2"};